import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getCardDetails } from "redux/actions/usersActions";
import { Card, CardContent, Box, Grid, Typography } from "@mui/material";
import { CardTitle } from "reactstrap";
import DataCard from "../../../../../components/DataCard";
import PaginationTable from "components/PaginationTable";
import { GET_CARD_TRANSACTIONS } from "config/apiRoutes";
import { getCardBalancesRequestAction } from "redux/actions/cardActions";
// --------------------------------------------------------------------------------
const CardDetail = () => {
  const dispatch = useDispatch();
  const { id: cardId } = useParams();

  const [card, setCard] = useState([]);
  const [cardBalances, setCardBalances] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showLimitsAndStatus, setShow] = useState(true);
  const [data, setData] = useState({ records: [] });
  const paginationTableRef = useRef();

  useEffect(() => {
    if (cardId)
      dispatch(
        getCardDetails({
          cardId,
          onSuccess: (data) => {
            setCard(data);
            dispatch(
              getCardBalancesRequestAction({
                email: data.email,
                onSuccess: (data) => setCardBalances(data),
              })
            );
          },
        })
      );
  }, [cardId]);

  useEffect(() => {
    !isInitialLoad
      ? paginationTableRef.current.refetch()
      : setIsInitialLoad(false);
  }, []);

  useEffect(() => {
    if (card.type) {
      if (
        (card.type === "plastic" && card.status === "cancel") ||
        (card.type === "virtual" && card.status === "remove")
      ) {
        setShow(false);
      }
    }
  }, [card]);

  const columns = useMemo(() => {
    const baseColumns = [
      { accessorKey: "transaction_status", header: "Transaction Status" },
      { accessorKey: "transaction_amount", header: "Transaction Amount" },
      { accessorKey: "transaction_currency", header: "Transaction Currency" },
      { accessorKey: "terminal_type", header: "Terminal Type" },
      { accessorKey: "mcc", header: "MCC" },
      { accessorKey: "description", header: "Description" },
      { accessorKey: "rrn", header: "RRN" },
      { accessorKey: "transaction_date_time", header: "Transaction Time" },
      { accessorKey: "card_holer_name", header: "Card Name" },
    ];

    return baseColumns;
  }, []);

  return (
    <>
      <Card sx={{ p: 2, mb: 2 }}>
        <CardTitle>Card Detail</CardTitle>
        <CardContent>
          <Grid container>
            <Grid item xs={6}>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>
                  Masked Card Number:{" "}
                </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.card_number}
                </Typography>
              </Grid>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>Card Type: </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.type}
                </Typography>
              </Grid>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>Card Brand: </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.brand}
                </Typography>
              </Grid>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>
                  Card Status:{" "}
                </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.status}
                </Typography>
              </Grid>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>
                  Created Time:{" "}
                </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.created_time}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>
                  User's Full Name:{" "}
                </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.first_name} {card.last_name}
                </Typography>
              </Grid>
              <Grid sx={{ mb: 2 }}>
                <Typography sx={{ display: "inline" }}>User Email: </Typography>
                <Typography sx={{ display: "inline", fontWeight: "bold" }}>
                  {card.email}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card sx={{ p: 2, mb: 2 }}>
        <CardTitle>Card Balance</CardTitle>
        <CardContent>
          <Box sx={{ display: "flex", flexFlow: "wrap" }}>
            {cardBalances.map((card) => (
              <DataCard title={card.balance} subTitle={card.currency} />
            ))}
          </Box>
        </CardContent>
      </Card>
      <Card sx={{ mb: 2 }}>
        <PaginationTable
          ref={paginationTableRef}
          apiEndpoint={GET_CARD_TRANSACTIONS}
          title="Card Transactions"
          //renderTopToolbar={renderTopToolbar}
          columns={columns}
          data={data.records}
          // onPaginationChange={setPagination}
          // state={{ pagination, loading: false }}
          // rowCount={data.count}
          initialFilters={{ cardId: cardId }}
          quarterRange
        />
      </Card>
    </>
  );
};

export default CardDetail;
